import themeActionTypes from "./theme.types";

const INITIAL_STATE = {
  theme: localStorage.getItem("selectedTheme"),
};

const themeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case themeActionTypes.SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    default:
      return state;
  }
};

export default themeReducer;
